"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EducationTypes = void 0;
var EducationTypes;
(function (EducationTypes) {
    EducationTypes["ASSOCIATES"] = "associates";
    EducationTypes["BACHELORS"] = "bachelors";
    EducationTypes["DOCTORATE"] = "doctorate";
    EducationTypes["NO_DIPLOMA"] = "no high school diploma";
    EducationTypes["HIGH_SCHOOL"] = "high school";
    EducationTypes["MASTERS"] = "masters";
    EducationTypes["MEDICAL_SCHOOL"] = "medical school";
    EducationTypes["LAW_SCHOOL"] = "law school";
    EducationTypes["VOCATIONAL_CERTIFICATE"] = "vocational certificate";
    EducationTypes["OTHER"] = "other";
})(EducationTypes = exports.EducationTypes || (exports.EducationTypes = {}));
